import Encoding from "encoding-japanese";

const UTF8_BOM = new Uint8Array([0xef, 0xbb, 0xbf]).buffer;

// See documentation: https://www.npmjs.com/package/encoding-japanese
const convertToSjisBytes = (text: string): ArrayBuffer => {
  const unicodeArray = Encoding.stringToCode(text);
  const sjisArray = Encoding.convert(unicodeArray, {
    to: "SJIS",
    from: "UNICODE",
  });
  return new Uint8Array(sjisArray).buffer;
};

type DownloadFileOptions = {
  filename: string;
  content: string;
  encoding: "utf-8" | "Shift_JIS";
};

/* Build the file as a Blob, then simulate a click on a link to it to download it */
export const downloadFile = ({
  filename,
  content,
  encoding,
}: DownloadFileOptions) => {
  const bodyPart: BlobPart =
    encoding === "Shift_JIS" ? convertToSjisBytes(content) : content;

  const blob = new Blob([UTF8_BOM, bodyPart], {
    type: `text/csv;charset=${encoding}`,
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  // Filename should already include .csv extension from the caller
  const downloadFilename = filename.endsWith(".csv")
    ? filename
    : `${filename}.csv`;
  link.setAttribute("download", downloadFilename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
